import { isEmpty } from 'mc-ui-utils';
import videoconfig from '../constants/videoconfig';
import State from '../state';
import { startPendingProgressBarAnimation } from './progressbarhelper';
/***
 *
 * https://developers.google.com/youtube/iframe_api_reference
 */
export const initializeYoutubePlayer = (element, videoId, isMuted, onPlayerReady, onPlayerStateChange, onError) => {
    if (element) {
        return new window.YT.Player(element.id, {
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                autoplay: 1,
                cc_load_policy: 0,
                disablekb: 1,
                controls: 0,
                frameborder: 0,
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                playlist: videoId,
                loop: 1,
                fs: 0,
                width: '100%',
                playsinline: 0,
                iv_load_policy: 3,
                mute: isMuted ? 1 : 0,
            },
            videoId,
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
                onError: (er) => {
                    console.error(er);
                    onError(er);
                },
            },
        });
    }
};
/***
 * To prevent browser downloading video in background even though it is in paused + invisible condition
 */
export const resetVideo = (videoPlayer, glanceId, playedTime) => {
    const currentTime = videoPlayer.currentTime || playedTime;
    const videoUrl = videoPlayer.currentSrc;
    //if (hasLoadedMetaData) {
    /*  videoPlayer.preload = 'none';
    //}
    videoPlayer.src = null;
    videoPlayer.load();
    videoPlayer.src = videoUrl; */
    if (!isNaN(currentTime) && isFinite(currentTime)) {
        State.setVideoTimeline(glanceId, currentTime);
        videoPlayer.currentTime = Math.floor(currentTime);
    }
    // videoPlayer.load();
};
export const isIOS = () => {
    if (navigator && navigator.platform) {
        return ([
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document));
    }
};
export const onMetaDataLoadCb = (videoPlayer, glanceId, isActiveGlance) => {
    if (!isEmpty(videoPlayer.duration)) {
        const duration = videoPlayer.duration * 1000;
        State.setStoryDuration(glanceId, duration);
        // change current animation duration if playing
        if (isActiveGlance) {
            startPendingProgressBarAnimation(glanceId, duration);
        }
    }
};
/***
 * deprecated
 */
export const getPosterUrl = (videoUrl) => {
    return videoUrl.substr(0, videoUrl.lastIndexOf('.')) + '.jpg';
};
export const getFileSize = (range) => parseInt(range.match(/\/(\d+)$/)[1]);
export const getBufferedTime = (ranges) => {
    let tt = 0;
    for (let i = 0, len = ranges.length; i < len; i += 1) {
        tt = Math.max(tt, ranges.end(i));
    }
    return tt;
};
export const getNetworkOptimisedVideoUrl = (videoUrl) => {
    const filename = videoUrl.substr(videoUrl.lastIndexOf('/') + 1);
    const extension = filename.substr(filename.lastIndexOf('.') + 1);
    const name = filename.substr(0, filename.lastIndexOf('.'));
    return videoUrl.replace(filename, `${name}_4g.${extension}#t2`);
};
export const getStartTime = (totalFileSize, duration, currentTime) => {
    const start = Math.round((totalFileSize / duration) * currentTime);
    const end = start + videoconfig.CHUNK_SIZE_LIMIT;
    return {
        start,
        end,
    };
};
//# sourceMappingURL=videohelper.js.map